import webApi from './webApi'
import { ApiClient } from './ApiClient'
import { IRole, UserRoles } from '../types/Permission/IRoles'

const GetRoles = async (
    apiClient: ApiClient
): Promise<UserRoles> => {
    const response = await webApi.get<UserRoles>(apiClient, {
        url: `/api/roles`,
        params: {}
    })

    if (Array.isArray(response)) {
        return response
    }
    if (typeof response === 'string') {
        return [response as IRole]
    }
    return []
}

const permissionApi = {
    GetRoles
}

export default permissionApi